/**
 * Extract the basename from a URL object, which corresponds to the `url_key`
 * property of a Magento 2 GraphQL entity. Mostly used to get the url_key
 * from a recently navigated-to URL.
 *
 * @param {string} path
 * @returns {string} A string for use as the `url_key` in a GraphQL query.
 */
export function getUrlKeyForProduct(path: string) {
    const stripped = path
        .replace(/^\//, '') // strip leading slashes
        .replace(/\/$/, ''); // strip trailing slashes

    return (
        stripped
            .replace(/\.html$/, '')
            .split('/')
            .slice(-1)[0] || 'unknown'
    );
}
